import { getObjectFromJsonTag } from '../config';

export const translations = getObjectFromJsonTag('i18n');
